/** Canonical electricity values remain in kWh; display uses GWh (1 GWh = 1e6 kWh). */
export const KWH_PER_GWH = 1_000_000;

export function kwhToGwhNumber(kwh: number): number {
  return kwh / KWH_PER_GWH;
}

export function formatGwhFromKwh(kwh: number, fractionDigits = 1): string {
  if (!Number.isFinite(kwh)) return '—';
  return kwhToGwhNumber(kwh).toLocaleString(undefined, {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: 0,
  });
}

/** Headline / card value, e.g. `707.1 GWh` */
export function formatGwhHeadline(kwh: number): string {
  return `${formatGwhFromKwh(kwh)} GWh`;
}

/** Y-axis ticks from kWh-backed scale values */
export function formatGwhAxisTickFromKwh(kwh: number): string {
  const gwh = kwhToGwhNumber(kwh);
  const digits = Math.abs(gwh) >= 10 ? 0 : 1;
  return gwh.toLocaleString(undefined, { maximumFractionDigits: digits });
}

/** Tooltip primary line: `707.1 GWh (707,061,000 kWh)` */
export function formatElectricityTooltipPrimary(kwh: number): string {
  const roundedKwh = Math.round(kwh);
  return `${formatGwhFromKwh(kwh)} GWh (${roundedKwh.toLocaleString()} kWh)`;
}
